<template>
  <div style="background-color: #E3F2FD;" v-if="this.getdoctortype!==null">
    <b-container v-if="!requestSuccessful">
      <Widget>
        <b-form @submit.prevent="getOtp">
          <!--            doctortype_id-->
          <b-form-group id="doctortype_id_group" label="Doctor Type * :" label-for="doctortype_id"
                        description="Selest Your preferable field">
            <b-form-select id="doctortype_id" block required v-model="form.doctortype_id" text="Select Doctor Type">
              <option v-for="type in this.getdoctortype" :key="type.id" block :value="type.id"
                      style="font-weight: bold">
                {{ type.name }}
              </option>
            </b-form-select>
          </b-form-group>

          <!--            name-->
          <b-form-group id="name_group" label="Name * " label-for="name" description="The fullname of doctor.">
            <b-form-input id="name" v-model="form.name" type="text" required placeholder="Enter name"></b-form-input>
          </b-form-group>

          <b-row>
            <!--            bmdc_number-->
            <b-col>
              <b-form-group id="bmdc_number_group" label="BMDC Number * " label-for="bmdc_number"
                            description="BMDC number of doctor">
                <b-form-input id="bmdc_number" v-model="form.bmdc_number" type="text" required
                              placeholder="BMDC Number"></b-form-input>
              </b-form-group>
            </b-col>
            <!--            gender-->
            <b-col>
              <b-form-group id="gender_group" label="Gender *" label-for="gender" description="The gender of doctor.">
                <b-form-select id="gender" v-model="form.gender" type="number" :options="gender"
                               required></b-form-select>
              </b-form-group>
            </b-col>
          </b-row>

          <!--            mobile-->
          <b-form-group id="mobile_group" label="Mobile *" label-for="mobile"
                        description="The mobile of doctor. Must be unique.">
            <b-form-input id="mobile" v-model="form.mobile" required type="text"
                          placeholder="Enter mobile number"></b-form-input>
          </b-form-group>

          <!--            email-->
          <b-form-group id="email-group" label="Email address *" label-for="email"
                        description="The mail address of doctor.">
            <b-form-input id="email" v-model="form.email" type="email" required
                          placeholder="Enter email"></b-form-input>
          </b-form-group>

          <!--            workplace-->
          <b-form-group id="workplace_group" label="Work Place/ Chamber *" label-for="workplace"
                        description="The workplace of doctor.">
            <b-form-input id="workplace" v-model="form.workplace" type="text" required
                          placeholder="Enter doctor's work place"></b-form-input>
          </b-form-group>

          <!--            designation-->
          <b-form-group id="designation_group" label="Designation *" label-for="designation"
                        description="The designation of doctor.">
            <b-form-input id="designation" v-model="form.designation" type="text" required
                          placeholder="Enter Designation of Doctor"></b-form-input>
          </b-form-group>

          <!--            medical_college-->
          <b-form-group id="medical_college_group" label="Medical College *" label-for="medical_college"
                        description="The graduation college of doctor.">
            <b-form-input id="medical_college" v-model="form.medical_college.name" type="text" required
                          placeholder="Enter Medical College"></b-form-input>
          </b-form-group>

          <b-row>
            <b-col>
              <b-form-group id="batch_group" label="Batch *" label-for="batch" description="Enter your Batch number.">
                <b-form-input id="batch" v-model="form.medical_college.batch" type="text" required
                              placeholder="Batch"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group id="session_group" label="Session *" label-for="session" description="Enter Session.">
                <b-form-input id="session" v-model="form.medical_college.session" type="text" required
                              placeholder="Session"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>

          <!--          <b-form-group id="bmdc_id_group" label="Bmdc ID *" label-for="bmdc_id" description="Link your BMDC id.">-->
          <!--            <b-form-input id="bmdc_id" type="text" required placeholder="Link your BMDC id"></b-form-input>-->
          <!--          </b-form-group>-->

          <!--                      post_grad-->
          <b-form-group id="post_grad_group" label="Post Grad " label-for="post_grad"
                        description="Post Grad degree of doctor">
            <b-form-input id="post_grad" v-model="form.postgrad" type="text" placeholder="Post grad"></b-form-input>
          </b-form-group>

          <!--            others_training-->
          <b-form-group id="others_training_group" label="Others Training :" label-for="others_training"
                        description="Other degrees of doctor [can be blank].">
            <b-form-input id="others_training" v-model="form.other_trainings" type="text"
                          placeholder="Other Trainings"></b-form-input>
          </b-form-group>


          <b-row>
            <b-col>
              <b-form-group id="password_group" label="Password *" label-for="password"
                            description="password must contain 6 characters">
                <b-form-input
                    id="password"
                    v-model="form.password"
                    type="password"
                    required
                    placeholder="Password"
                >
                </b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group id="confirm_password_group" label="Confirm Password *" label-for="confirm_password">
                <b-form-input
                    id="confirm_password"
                    v-model="form.password_confirmation"
                    :state="form.password===form.password_confirmation && form.password_confirmation!==null ? true : false"
                    type="password"
                    required
                    placeholder="Confirm Password"
                >
                </b-form-input>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row v-if="showVerifyButton===false && showCreateButton===true">
            <b-col>
              <b-form-group id="otp_group" label="4 digit otp *" label-for="otp"
                            description="Enter the 4 digit number send to your phone number">
                <b-form-input id="otp" v-model="validation_form.otp_code" type="number" required
                              placeholder="OTP code"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>


          <b-row v-if="showCreateButton">
            <div style="padding-right: 10px; padding-left: 15px; ">
              <b-button variant="success" @click="create">Create</b-button>
            </div>
          </b-row>

          <b-row v-if="showVerifyButton">
            <div style="padding-right: 10px; padding-left: 15px; ">
              <b-button type="submit" variant="danger">Verify</b-button>
            </div>
          </b-row>
        </b-form>
      </Widget>
    </b-container>
    <b-container v-else>
      <P style="padding-bottom: 2px; padding-left: 5px;">Your request was successful. We will verify as soon as possible.</P>
    </b-container>
    <P style="padding-bottom: 2px; padding-left: 5px;">@EKHONI DAKTAR</P>
  </div>
</template>

<script>
import {Form} from "vform";
import {mapGetters} from 'vuex';
import AuthService from '@/services/doctor/auth.service';

export default {
  name: "Request",
  data() {
    return {
      form: new Form(
          {
            doctortype_id: null,
            payment_style: null,
            name: null,
            bmdc_number: null,
            rate: 0,
            offer_rate: 0,
            followup_rate: 0,
            report_followup_rate: 0,
            gender: null,
            mobile: '880',
            email: null,
            workplace: null,
            designation: null,
            medical_college: {
              name: '',
              session: '',
              batch: '',
            },
            postgrad: null,
            other_trainings: null,
            password: null,
            password_confirmation: null,
            portfolio: 'ok',
          }
      ),
      validation_form: new Form({
        mobile: '',
        otp_code: '',
      }),
      doctorTypes: null,
      selectedDoctorType: null,
      gender: [{text: 'Male', value: 0}, {text: 'Female', value: 1}],
      value: '',
      showCreateButton: false,
      showVerifyButton: true,
      requestSuccessful: false,
    }
  },
  computed: {
    ...mapGetters('doctorAuth', ['getdoctortype']),
  },
  methods: {
    create() {
      this.validation_form.mobile = this.form.mobile;
      AuthService.validateDoctorRequest(this.validation_form)
          .then((response) => {
            if (response.status === 204) {

              // console.log(this.form.medical_college);
              AuthService.sendDoctorCreationRequest(this.form)
                  .then((response) => {
                    if (response.status === 201) {
                      //alert('doctor application successfully submiited');
                      this.$toasted.success("request has been accepted successfully", {
                        theme: "toasted-primary",
                        position: "top-right",
                        duration: 3000,
                        icon: 'check',
                      });
                      this.form.reset();
                      this.requestSuccessful = true;
                    }
                  })

            }
          })
          .catch((e) => {
            this.validation_form.otp_code = '';
            this.showCreateButton = true;
            this.showVerifyButton = false;
            if (e.status === 401) {
              this.$toasted.error("user request failed", {
                theme: "toasted-primary",
                position: "top-right",
                duration: 3000,
                icon: 'check',
              });
            }
            if (e.status === 422) {
              this.$toasted.error("Number is already used", {
                theme: "toasted-primary",
                position: "top-right",
                duration: 3000,
                icon: 'check',
              });
            }
          })

    },
    getOtp() {
      if (!this.form.mobile.startsWith('88')) {
        this.$toasted.info("Bangladeshi Number must start with 880", {
          theme: "toasted-primary",
          position: "top-right",
          duration: 1500,
          icon: 'check',
        });
      }

      this.$toasted.info("Please enter the 4 digit otp", {
        theme: "toasted-primary",
        position: "top-right",
        duration: 1500,
        icon: 'check',
      });

      if (this.form.password === this.form.password_confirmation && this.form.password !== null) {
        AuthService.requestOTP(this.form)
            .then((response) => {
              if (response.status === 201) {
                this.showCreateButton = true;
                this.showVerifyButton = false;
              }
            })
            .catch((e) => console.error(e))
      } else {
        alert('Confirm Password Donot Match');
      }
    },

  },
}
</script>

<style scoped>

</style>


<!--          &lt;!&ndash;            rate&ndash;&gt;-->
<!--          <b-form-group id="rate_group" label="Rate:" label-for="rate" description="The usual rate of doctor per call/appointment.">-->
<!--            <b-form-input id="rate" v-model="form.rate" type="number" required placeholder="Rate"></b-form-input>-->
<!--          </b-form-group>-->

<!--          &lt;!&ndash;            offer_rate&ndash;&gt;-->
<!--          <b-form-group id="offer_rate_group" label="Offer rate:" label-for="offer_rate" description="The discounted rate of doctor per call/appointment. If not presen it will be set to usual rate.">-->
<!--            <b-form-input id="Offer_rate" v-model="form.offer_rate" type="number" placeholder="Offer Rate"></b-form-input>-->
<!--          </b-form-group>-->

<!--          &lt;!&ndash;            first_appiontment_rate&ndash;&gt;-->
<!--          <b-form-group id="first_appointment_rate_group" label="First Appointment Rate:" label-for="first_appointment_rate" description="he initial appointment rate of doctor per patient. If not present it will be set to offer rate.">-->
<!--            <b-form-input id="first_appointment_rate" v-model="form.first_appointment_rate"  placeholder="First Appiontment Rate"></b-form-input>-->
<!--          </b-form-group>-->

<!--          &lt;!&ndash;            report_followup_rate&ndash;&gt;-->
<!--          <b-form-group id="report_followup_rate_group" label="Report Follow up Rate:" label-for="report_followup_rate" description="The rate of doctor appointment within a specific checkup period per patient. If not present it will be set to offer rate.">-->
<!--            <b-form-input id="report_followup_rate" v-model="form.report_followup_rate"  placeholder="Report Follow up Rate"></b-form-input>-->
<!--          </b-form-group>-->
